import { ApiUrl } from '@config/apiUrl';
import apiProtected from '@lib/api/apiClient';

export const server = ApiUrl.server_url;

export const getBody = async <T = any>(
  url: string,
  params?: object
): Promise<T> => {
  const { data } = await apiProtected.get<T>(url, { params });
  return data;
};

export const asList = <T>(body: { data?: T[] } | null | undefined): T[] =>
  body?.data ?? [];

type ApiError = {
  response?: { data?: { message?: string; status?: boolean } };
  message?: string;
};

export const errorBody = (
  error: unknown
): {
  message?: string;
  status?: boolean;
} => {
  const apiError = error as ApiError;
  return (
    apiError.response?.data ?? {
      status: false,
      message: apiError.message || 'An error occurred. Please try again.',
    }
  );
};
